import { GetServerSideProps, NextPage } from 'next'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-request'
import { RankHeader } from '~/components/pages/rank/RankHeader'
import { RankList } from '~/components/pages/rank/RankList'
import { AI_CREATORS_TYPE } from '~/components/pages/rank/types'
import { MyContainer } from '~/components/ui/MyContainer'
import { RANK_PAGE_SIZE } from '~/configs'
import { GET_AI_FANS_COUNT_RANK } from '~/graphqls/gqls'
import {
  getAiFansCountRank,
  getAiFansCountRankVariables,
  getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node,
  QueryDateEnum,
} from '~/graphqls/types'
import { Layout } from '~/layouts/default'
import { getGraphData, serverSideCatch } from '~/utils'

const RankSameStyle: NextPage<{
  rankData: getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node[]
}> = ({ rankData }) => {
  return (
    <Layout headerType="no-margin">
      <SEOHead title="粉丝榜-AI创作" />
      <RankHeader />

      <MyContainer>
        <div
          className="rounded-3xl py-4 px-12 -mt-[92px] mb-6"
          style={{
            background:
              'linear-gradient(0deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.04)), #141416',
          }}
        >
          <RankList data={rankData} type={AI_CREATORS_TYPE.FANS_COUNT} />
        </div>
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await serverSideCatch(async () => {
    const { initialState, client } = await GlobalRequest(context)

    const res = await client.query<
      getAiFansCountRank,
      getAiFansCountRankVariables
    >({
      query: GET_AI_FANS_COUNT_RANK,
      fetchPolicy: 'no-cache',
      variables: {
        first: RANK_PAGE_SIZE,
        offset: 0,
        date: QueryDateEnum.ALL_TIME,
      },
    })

    return {
      props: {
        initialState,
        rankData: getGraphData(
          res.data?.copyrightStatisticsModule?.rankList?.edges || []
        ),
      },
    }
  })
}

export default RankSameStyle
